import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'
import { FeatureToggle } from './featureToggles'

export const retailerCollectionsFlyersAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.Flyers],
}

export const flyerPageBuilderAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.Flyers],
  warehouseFeatureToggles: [FeatureToggle.retailerCreateDigitalFlyerEnabled],
}
